import { defineMessages } from 'react-intl';
/**
 * Official weather warnings: the warnings a national weather service issues for
 * a place (AEMET, DWD, Météo-France via MeteoAlarm, NOAA/NWS…), shown on the
 * station and location dashboards and on the warnings list. Not the user's own
 * station alerts, which live in `alerts` ("My alerts").
 *
 * Built by `packages/core/src/utils/WeatherWarnings/view.ts`.
 */
export default defineMessages({
    // ------------------------------------------------------------ hazards
    hazardWind: {
        id: 'weatherWarnings.hazardWind',
        defaultMessage: 'Wind'
    },
    hazardRain: {
        id: 'weatherWarnings.hazardRain',
        defaultMessage: 'Rain'
    },
    hazardThunderstorm: {
        id: 'weatherWarnings.hazardThunderstorm',
        defaultMessage: 'Thunderstorms'
    },
    hazardFlood: {
        id: 'weatherWarnings.hazardFlood',
        defaultMessage: 'Floods'
    },
    hazardSnowIce: {
        id: 'weatherWarnings.hazardSnowIce',
        defaultMessage: 'Snow and ice'
    },
    hazardAvalanche: {
        id: 'weatherWarnings.hazardAvalanche',
        defaultMessage: 'Avalanches'
    },
    hazardCoastalEvent: {
        id: 'weatherWarnings.hazardCoastalEvent',
        defaultMessage: 'Coastal hazards'
    },
    hazardFog: {
        id: 'weatherWarnings.hazardFog',
        defaultMessage: 'Fog'
    },
    hazardHighTemperature: {
        id: 'weatherWarnings.hazardHighTemperature',
        defaultMessage: 'High temperatures'
    },
    hazardLowTemperature: {
        id: 'weatherWarnings.hazardLowTemperature',
        defaultMessage: 'Low temperatures'
    },
    hazardForestFire: {
        id: 'weatherWarnings.hazardForestFire',
        defaultMessage: 'Forest fires'
    },
    hazardUv: {
        id: 'weatherWarnings.hazardUv',
        defaultMessage: 'UV radiation'
    },
    hazardAirQuality: {
        id: 'weatherWarnings.hazardAirQuality',
        defaultMessage: 'Air quality'
    },
    hazardOther: {
        id: 'weatherWarnings.hazardOther',
        defaultMessage: 'Other hazard'
    },
    // ------------------------------------------------------------ severity words
    severityMinor: {
        id: 'weatherWarnings.severityMinor',
        defaultMessage: 'Minor'
    },
    severityModerate: {
        id: 'weatherWarnings.severityModerate',
        defaultMessage: 'Moderate'
    },
    severitySevere: {
        id: 'weatherWarnings.severitySevere',
        defaultMessage: 'Severe'
    },
    severityExtreme: {
        id: 'weatherWarnings.severityExtreme',
        defaultMessage: 'Extreme'
    },
    // ------------------------------------------------------------ when
    fromTime: {
        id: 'weatherWarnings.fromTime',
        defaultMessage: 'From {time}'
    },
    severityNow: {
        id: 'weatherWarnings.severityNow',
        defaultMessage: '{severity} now'
    },
    severityFrom: {
        id: 'weatherWarnings.severityFrom',
        defaultMessage: '{severity} from {time}'
    },
    severityUntil: {
        id: 'weatherWarnings.severityUntil',
        defaultMessage: '{severity} until {time}'
    },
    // ------------------------------------------------------------ list
    activeNow: {
        id: 'weatherWarnings.activeNow',
        defaultMessage: 'Active now'
    },
    upcoming: {
        id: 'weatherWarnings.upcoming',
        defaultMessage: 'Upcoming'
    },
    lastUpdate: {
        id: 'weatherWarnings.lastUpdate',
        defaultMessage: 'Last update: {time}'
    },
    source: {
        id: 'weatherWarnings.source',
        defaultMessage: 'Source: {source}'
    },
    // ------------------------------------------------------------ screen reader
    spokenLabel: {
        id: 'weatherWarnings.spokenLabel',
        defaultMessage: '{count, plural, one {# official weather warning} other {# official weather warnings}}. {hazards}'
    },
    spokenHazardOne: {
        id: 'weatherWarnings.spokenHazardOne',
        defaultMessage: '{hazard}: {status}.'
    },
    spokenHazardTwo: {
        id: 'weatherWarnings.spokenHazardTwo',
        defaultMessage: '{hazard}: {first}, then {second}.'
    }
});
